module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.prevVisible),
      expression: "prevVisible"
    }],
    staticClass: "blog-nav",
    attrs: {
      "id": "prev",
      "href": "javascript:;"
    },
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("< PREV")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nextVisible),
      expression: "nextVisible"
    }],
    staticClass: "blog-nav",
    attrs: {
      "id": "next",
      "href": "javascript:;"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("NEXT >")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.2@vue-loader/lib/template-compiler?{"id":"data-v-d623ff7c"}!./~/.11.3.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Pager.vue
// module id = 157
// module chunks = 1